import axios from "axios";
import { Config } from "../../data/config";

export const SET_CONNECTION = "CONNECTION | SET_CONNECTION";
export const RESET_CONNECTION = "CONNECTION | RESET_CONNECTION";
export const SET_UNIT_NO = "CONNECTION | SET_UNIT_NO";
export const SET_BUILDING_NO = "CONNECTION | SET_BUILDING_NO";
export const SET_STATUS = "CONNECTION | SET_STATUS";
export const SET_AUTOFOCUS = "CONNECTION | SET_AUTOFOCUS";

export function setConnection(data) {
  return { type: SET_CONNECTION, payload: data };
}

export function resetConnection() {
  return { type: RESET_CONNECTION };
}

export function setUnitNo(value) {
  return { type: SET_UNIT_NO, payload: value };
}

export function setBuildingNo(value) {
  return { type: SET_BUILDING_NO, payload: value };
}

export function setStatus(value) {
  return { type: SET_STATUS, payload: value };
}


export function checkCompatibility(request) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${Config.frontApiUrl}/availability/compatible`, request)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
    });
  };
}

export function setAutofocus(flag) {
  return { type: SET_AUTOFOCUS, payload: flag };
}


// WEBPACK FOOTER //
// ./src/store/actions/connection.js